import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

interface SubscriptionData {
  amount: number | null;
  interval: string | null;
  status: string;
  plan_name: string | null;
}

export function useSubscription() {
  const { session } = useAuth();

  return useQuery<SubscriptionData>({
    queryKey: ['subscription'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('get-subscription');
      if (error) throw error;
      return data as SubscriptionData;
    },
    enabled: !!session,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
